module.exports = __webpack_public_path__ + "static/img/3.44b974a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/VTS/3.png
// module id = 3F1M
// module chunks = 1